import { StyleSheet } from 'aphrodite/no-important';

import {
  palettes,
  typography,
  spacers,
  borderRadius,
} from '../../node_modules/@trainline/depot-web/css/themes/trainline';

export default StyleSheet.create({
  bookingListContainer: {
    fontSize: typography.dp_small_font_size_m,
    border: `1px solid ${palettes.dp_app_border_base}`,
    borderRadius: `0 0 ${borderRadius.dp_r8} ${borderRadius.dp_r8}`,
  },
  wrapper: {
    paddingTop: spacers.dp_s24,
  },
  container: {
    marginTop: 0,
  },
});
